/**
 * MediaGalleryModal.jsx
 * Created by michaelbray on 7/11/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Gallery from './Gallery';
import * as Icons from './icons/Icons';

const propTypes = {
    mediaItems: PropTypes.array,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    activeIndex: PropTypes.number,
    displayThumbnail: PropTypes.bool
};

const defaultProps = {
    mediaItems: [],
    isOpen: false,
    activeIndex: 0,
    displayThumbnail: true
};

export class MediaGalleryModal extends React.PureComponent {
    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                onRequestClose={this.props.onRequestClose}
                role="complementary"
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md rec-modal-image-gallery',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open rec-modal-image-gallery',
                    beforeClose: 'rec-overlay-before-close'
                }}
                contentLabel="Media Gallery">
                <div className="rec-modal-content-wrap">
                    <button
                        className="rec-close-modal"
                        onClick={this.props.onRequestClose}>
                        <Icons.IconClose />
                    </button>

                    <Gallery
                        images={this.props.mediaItems}
                        activeIndex={this.props.activeIndex}
                        displayThumbnail={this.props.displayThumbnail} />
                </div>
            </Modal>
        );
    }
}

MediaGalleryModal.propTypes = propTypes;
MediaGalleryModal.defaultProps = defaultProps;

export default MediaGalleryModal;
